import React, { Component } from 'react';
import { useLocation } from 'react-router-dom';
import { reportClientError } from '../../services/clientErrorService';
import ErrorFallback from './ErrorFallback';

const createErrorReferenceId = () => {
  const timestamp = Date.now().toString(36).toUpperCase();
  const random = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `TR-${timestamp}-${random}`;
};

class ErrorBoundaryBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorReferenceId: null,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
      errorReferenceId: createErrorReferenceId(),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false, errorReferenceId: null });
    }
  }

  componentDidCatch(error, errorInfo) {
    reportClientError({
      error,
      errorInfo,
      source: 'error_boundary',
      metadata: {
        error_reference_id: this.state.errorReferenceId,
        reset_key: this.props.resetKey,
      },
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, errorReferenceId: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback
          errorReferenceId={this.state.errorReferenceId}
          onReset={this.handleReset}
        />
      );
    }

    return this.props.children;
  }
}

export default function ErrorBoundary({ children }) {
  const location = useLocation();

  return (
    <ErrorBoundaryBase resetKey={location.pathname}>
      {children}
    </ErrorBoundaryBase>
  );
}
